import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import humanRemainsImg from "../../../../assets/imgs/services/nationals/human-remains.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import humanremains1Icon from "../../../../assets/imgs/services/nationals/hightech-icons/hightech2.svg";
import humanremains2Icon from "../../../../assets/imgs/services/nationals/humanremains-icons/humanremains1.svg";
import humanremains3Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg"
import humanremains4Icon from "../../../../assets/imgs/services/nationals/humanremains-icons/humanremains2.svg";
import humanremains5Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals6.svg"
import humanremains6Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals5.svg"
import NationalDescription from "../../../../components/national-description/national-description";

function HumanRemains() {
  const [tHumanRemains] = useTranslation("humanRemainsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idHumanRemains = "6a1613dd-4bc4-4d29-b519-24eb5e068063";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[7]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[7]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHumanRemains}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Embalaje y Manejo Especial"]
              .content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Packaging and Special Handling"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("restosHumanos.title")}</title>
        <meta
          name="description"
          content={tSMetaData("restosHumanos.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tHumanRemains("header.section")}
        title={tHumanRemains("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tHumanRemains("description.content"))
        }
        quoteBtn={tHumanRemains("header.quote-btn")}
        quoteProductID="btnQuoteRemains"
        contactSales={tHumanRemains("header.contact-sales")}
        contactProductID="btnContactRemains"
        imgBackground={humanRemainsImg}
      /> */}
      <ImageHeader
        imgBackground={humanRemainsImg}
      />
      {/* <Accordion
        title={tHumanRemains("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tHumanRemains("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHumanRemains("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tHumanRemains("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHumanRemains("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tHumanRemains("accordion-3.content"))
        }
      /> */}
      <div className="info-national-content">
        <NationalDescription
          title={tHumanRemains("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tHumanRemains("header.quote-btn")}
          quoteProductID="btnQuoteGold"
          contactSales={tHumanRemains("header.contact-sales")}
          contactProductID="btnContactGold"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tHumanRemains("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tHumanRemains("accordion-1.title")}
              content={
                accordion1
                  ? JSON.parse(accordion1) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tHumanRemains("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tHumanRemains("accordion-3.title")}
              content={
                accordion3
                  ? JSON.parse(accordion3) : "{}"
              }
            />
          </div>
          
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tHumanRemains("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={humanremains1Icon} /></div>
              <p>{tHumanRemains("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={humanremains2Icon} /></div>
              <p>{tHumanRemains("non-applicable-charges.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={humanremains3Icon} /></div>
              <p>{tHumanRemains("non-applicable-charges.item3")}</p>
            </div>

          </div>
        </div>

        <div className="more-info-box">
          <h5>{tHumanRemains("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={humanremains4Icon} /></div>
              <p>{tHumanRemains("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={humanremains5Icon} /></div>
              <p>{tHumanRemains("additional-conditions.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={humanremains6Icon} /></div>
              <p>{tHumanRemains("additional-conditions.item3")}</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default HumanRemains;
